import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileBarChart, CalendarIcon, PrinterIcon, SearchIcon } from 'lucide-react';
interface DetentionRecord {
  id: string;
  gatePassNo: string;
  vehicleNo: string;
  vehicleType: string;
  entryDate: string;
  entryFee: number;
  parkingFee: number;
  noOfDays: number;
}
const mockData: DetentionRecord[] = [{
  id: '1',
  gatePassNo: 'GP-2026-0001',
  vehicleNo: 'MH-12-AB-1234',
  vehicleType: 'Truck',
  entryDate: '2026-04-10 08:30 AM',
  entryFee: 150,
  parkingFee: 1000,
  noOfDays: 5
}, {
  id: '2',
  gatePassNo: 'GP-2026-0002',
  vehicleNo: 'MH-14-CD-5678',
  vehicleType: 'Car',
  entryDate: '2026-04-12 09:15 AM',
  entryFee: 50,
  parkingFee: 300,
  noOfDays: 3
}, {
  id: '3',
  gatePassNo: 'GP-2026-0003',
  vehicleNo: 'GJ-05-EF-9012',
  vehicleType: 'Van',
  entryDate: '2026-04-13 09:45 AM',
  entryFee: 100,
  parkingFee: 300,
  noOfDays: 2
}, {
  id: '4',
  gatePassNo: 'GP-2026-0004',
  vehicleNo: 'DL-01-GH-3456',
  vehicleType: 'Trailer',
  entryDate: '2026-04-08 10:00 AM',
  entryFee: 200,
  parkingFee: 1750,
  noOfDays: 7
}, {
  id: '5',
  gatePassNo: 'GP-2026-0005',
  vehicleNo: 'RJ-14-IJ-7890',
  vehicleType: 'Truck',
  entryDate: '2026-04-14 10:30 AM',
  entryFee: 150,
  parkingFee: 200,
  noOfDays: 1
}, {
  id: '6',
  gatePassNo: 'GP-2026-0006',
  vehicleNo: 'KA-01-KL-2345',
  vehicleType: 'Car',
  entryDate: '2026-04-11 11:00 AM',
  entryFee: 50,
  parkingFee: 400,
  noOfDays: 4
}, {
  id: '7',
  gatePassNo: 'GP-2026-0007',
  vehicleNo: 'TN-09-MN-6789',
  vehicleType: 'Bike',
  entryDate: '2026-04-15 11:20 AM',
  entryFee: 20,
  parkingFee: 50,
  noOfDays: 0
}, {
  id: '8',
  gatePassNo: 'GP-2026-0008',
  vehicleNo: 'UP-32-OP-0123',
  vehicleType: 'Truck',
  entryDate: '2026-04-05 11:45 AM',
  entryFee: 150,
  parkingFee: 2000,
  noOfDays: 10
}, {
  id: '9',
  gatePassNo: 'GP-2026-0009',
  vehicleNo: 'MP-09-QR-4567',
  vehicleType: 'Van',
  entryDate: '2026-04-14 12:10 PM',
  entryFee: 100,
  parkingFee: 150,
  noOfDays: 1
}, {
  id: '10',
  gatePassNo: 'GP-2026-0010',
  vehicleNo: 'HR-26-ST-8901',
  vehicleType: 'Trailer',
  entryDate: '2026-04-12 12:30 PM',
  entryFee: 200,
  parkingFee: 750,
  noOfDays: 3
}, {
  id: '11',
  gatePassNo: 'GP-2026-0011',
  vehicleNo: 'MH-12-XY-9999',
  vehicleType: 'Truck',
  entryDate: '2026-04-13 02:30 PM',
  entryFee: 150,
  parkingFee: 400,
  noOfDays: 2
}, {
  id: '12',
  gatePassNo: 'GP-2026-0012',
  vehicleNo: 'GJ-01-AB-1111',
  vehicleType: 'Car',
  entryDate: '2026-04-14 04:15 PM',
  entryFee: 50,
  parkingFee: 100,
  noOfDays: 1
}];
export function VehicleDetentionReportPage() {
  const [startDate, setStartDate] = useState('2026-04-01');
  const [endDate, setEndDate] = useState('2026-04-15');
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleGenerate = () => {
    setHasGenerated(true);
  };
  const handlePrint = () => {
    document.body.classList.add('print-a4');
    window.print();
    document.body.classList.remove('print-a4');
  };
  const totalEntryFee = mockData.reduce((sum, row) => sum + row.entryFee, 0);
  const totalParkingFee = mockData.reduce((sum, row) => sum + row.parkingFee, 0);
  return <div className="w-full max-w-6xl mx-auto" data-id="element-1457">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-5 xs:p-6 sm:p-8 no-print" data-id="element-1458">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-1459">
          <div className="flex items-center gap-3" data-id="element-1460">
            <div className="bg-brand-teal/10 p-2 rounded-xl border border-brand-teal/20" data-id="element-1461">
              <FileBarChart className="w-6 h-6 text-brand-teal" data-id="element-1462" />
            </div>
            <div data-id="element-1463">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-1464">
                Vehicle Detention Report
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1465">
                View and print detained vehicles and their accumulated fees.
              </p>
            </div>
          </div>
          {hasGenerated && <button onClick={handlePrint} className="inline-flex items-center justify-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors" data-id="element-1466">
              <PrinterIcon className="w-4 h-4" data-id="element-1467" />
              Print Report
            </button>}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-1468">
          <div className="flex-1" data-id="element-1469">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1470">
              Start Date
            </label>
            <div className="relative" data-id="element-1471">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1472" />
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1473" />
            </div>
          </div>
          <div className="flex-1" data-id="element-1474">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1475">
              End Date
            </label>
            <div className="relative" data-id="element-1476">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1477" />
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1478" />
            </div>
          </div>
          <div className="flex items-end" data-id="element-1479">
            <button onClick={handleGenerate} className="w-full sm:w-auto px-6 py-2.5 bg-slate-800 text-white rounded-xl font-medium text-sm hover:bg-slate-700 transition-colors flex items-center justify-center gap-2 h-[42px]" data-id="element-1480">
              <SearchIcon className="w-4 h-4" data-id="element-1481" />
              Generate
            </button>
          </div>
        </div>

        {/* Screen Data Table */}
        {hasGenerated && <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-1482">
            <div className="overflow-x-auto" data-id="element-1483">
              <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-1484">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-1485">
                  <tr data-id="element-1486">
                    <th className="px-4 py-3 font-semibold" data-id="element-1487">Gate Pass No.</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-1488">Vehicle No.</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-1489">Vehicle Type</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-1490">Entry Date</th>
                    <th className="px-4 py-3 font-semibold text-right" data-id="element-1491">
                      Entry Fee (₹)
                    </th>
                    <th className="px-4 py-3 font-semibold text-right" data-id="element-1492">
                      Parking Fee (₹)
                    </th>
                    <th className="px-4 py-3 font-semibold text-center" data-id="element-1493">
                      No. of Days
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-1494">
                  {mockData.map(row => <tr key={row.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-1495">
                      <td className="px-4 py-3 font-mono text-slate-700 font-medium" data-id="element-1496">
                        {row.gatePassNo}
                      </td>
                      <td className="px-4 py-3 font-mono text-slate-900 font-bold" data-id="element-1497">
                        {row.vehicleNo}
                      </td>
                      <td className="px-4 py-3 text-slate-600" data-id="element-1498">
                        {row.vehicleType}
                      </td>
                      <td className="px-4 py-3 text-slate-600" data-id="element-1499">
                        {row.entryDate}
                      </td>
                      <td className="px-4 py-3 text-right text-slate-700" data-id="element-1500">
                        {row.entryFee.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 text-right text-slate-700" data-id="element-1501">
                        {row.parkingFee.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 text-center" data-id="element-1502">
                        <span className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-md bg-slate-100 text-slate-700 text-xs font-semibold" data-id="element-1503">
                          {row.noOfDays}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
                <tfoot className="bg-slate-50 border-t border-slate-200 font-bold text-slate-900" data-id="element-1504">
                  <tr data-id="element-1505">
                    <td colSpan={4} className="px-4 py-3 text-right" data-id="element-1506">
                      Total:
                    </td>
                    <td className="px-4 py-3 text-right text-brand-teal" data-id="element-1507">
                      ₹{totalEntryFee.toFixed(2)}
                    </td>
                    <td className="px-4 py-3 text-right text-brand-teal" data-id="element-1508">
                      ₹{totalParkingFee.toFixed(2)}
                    </td>
                    <td className="px-4 py-3" data-id="element-1509"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>}
      </motion.div>

      {/* Print Only Layout */}
      {hasGenerated && <div id="print-a4-report" className="hidden print:block bg-white text-black p-8" data-id="element-1510">
          {/* Print Header */}
          <div className="text-center mb-8 border-b-2 border-black pb-6" data-id="element-1511">
            <h1 className="text-2xl font-bold tracking-tight mb-1" data-id="element-1512">
              ERPLogiPark
            </h1>
            <p className="text-sm text-gray-600 mb-4" data-id="element-1513">
              Plot No. 45, Logistics Hub, Sector 18, Industrial Area, Bangalore
              - 560100
            </p>
            <h2 className="text-xl font-bold uppercase tracking-wider mb-2" data-id="element-1514">
              Vehicle Detention Report
            </h2>
            <p className="text-sm font-medium" data-id="element-1515">
              Period: {startDate} to {endDate}
            </p>
          </div>

          {/* Print Table */}
          <table className="w-full text-left text-sm border-collapse" data-id="element-1516">
            <thead data-id="element-1517">
              <tr className="border-b-2 border-black" data-id="element-1518">
                <th className="py-2 pr-2 font-bold" data-id="element-1519">Gate Pass No.</th>
                <th className="py-2 px-2 font-bold" data-id="element-1520">Vehicle No.</th>
                <th className="py-2 px-2 font-bold" data-id="element-1521">Type</th>
                <th className="py-2 px-2 font-bold" data-id="element-1522">Entry Date</th>
                <th className="py-2 px-2 font-bold text-right" data-id="element-1523">Entry Fee</th>
                <th className="py-2 px-2 font-bold text-right" data-id="element-1524">Parking Fee</th>
                <th className="py-2 pl-2 font-bold text-center" data-id="element-1525">Days</th>
              </tr>
            </thead>
            <tbody data-id="element-1526">
              {mockData.map((row, index) => <tr key={row.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-1527">
                  <td className="py-2 pr-2 border-b border-gray-200 font-mono text-xs" data-id="element-1528">
                    {row.gatePassNo}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 font-mono font-bold text-xs" data-id="element-1529">
                    {row.vehicleNo}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-xs" data-id="element-1530">
                    {row.vehicleType}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-xs" data-id="element-1531">
                    {row.entryDate}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-right text-xs" data-id="element-1532">
                    {row.entryFee.toFixed(2)}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-right text-xs" data-id="element-1533">
                    {row.parkingFee.toFixed(2)}
                  </td>
                  <td className="py-2 pl-2 border-b border-gray-200 text-center text-xs" data-id="element-1534">
                    {row.noOfDays}
                  </td>
                </tr>)}
            </tbody>
            <tfoot data-id="element-1535">
              <tr className="border-t-2 border-black font-bold" data-id="element-1536">
                <td colSpan={4} className="py-3 pr-2 text-right" data-id="element-1537">
                  TOTAL:
                </td>
                <td className="py-3 px-2 text-right" data-id="element-1538">
                  {totalEntryFee.toFixed(2)}
                </td>
                <td className="py-3 px-2 text-right" data-id="element-1539">
                  {totalParkingFee.toFixed(2)}
                </td>
                <td className="py-3 pl-2" data-id="element-1540"></td>
              </tr>
            </tfoot>
          </table>

          {/* Print Footer */}
          <div className="mt-12 text-xs text-gray-500 flex justify-between" data-id="element-1541">
            <p data-id="element-1542">Generated on: {new Date().toLocaleString()}</p>
            <p data-id="element-1543">Page 1 of 1</p>
          </div>
        </div>}
    </div>;
}